export const environment = {
  production: false,
  bankIdGatewayUrl: 'https://api-samtycke-bankid-gw-test.samtycke.net/service',
  dataServiceUrl: 'https://api-samtycke-be-test.samtycke.net/api',
  domain: 'admin.bildsamtycke.se'
}